import { on } from "delegated-events";
import { gsap } from "gsap";

const siteMenuTrigger = document.querySelector(".site-menu-trigger");
const siteMenu = document.querySelector(".site-menu");

const openMenu = () => {
  siteMenuTrigger.setAttribute("aria-label", "Close main menu");
  siteMenuTrigger.setAttribute("aria-expanded", "true");
  siteMenu.setAttribute("aria-hidden", "false");
  document.documentElement.classList.add("js-menu-active");

  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    gsap.set(".site-menu-circles", { xPercent: -200, yPercent: -200 });
    gsap.set(".site-menu-mobile-close", { yPercent: 200, opacity: 0 });
    gsap.set(".site-menu-wrapper", { xPercent: -100 });
    gsap.set(".site-menu-actions a, .site-menu-actions button, .site-menu-wrapper li", { y: "60%", opacity: 0 });
    gsap.set(".site-menu-section-line", { height: 0 });
    gsap.set(".site-menu-bottom-line", { width: 0 });

    const timeline = gsap.timeline();

    if (window.matchMedia("(max-width: 767px)").matches) {
      timeline.to(".site-menu-circles", { xPercent: 0, yPercent: 0, duration: 0.8, ease: "expoScale(0.5, 7, none)" });
      timeline.to(".site-menu-mobile-close", {
        yPercent: 0,
        opacity: 1,
        duration: 0.4,
        ease: "expoScale(0.5, 7, none)",
      });
    }

    timeline.to(".site-menu-wrapper", { xPercent: 0, duration: 0.4, ease: "expoScale(0.5, 7, none)" }, "<");
    timeline.to(".site-menu-section-line", { height: "100%" });
    timeline.to(
      ".site-menu-actions a, .site-menu-actions button, .site-menu-wrapper li",
      {
        y: 0,
        opacity: 1,
        duration: 0.3,
        stagger: 0.03,
        ease: "expoScale(0.5, 7, none)",
      },
      "<",
    );
    timeline.to(".site-menu-bottom-line", { width: "100%" }, "<50%");
  }
};

const closeMenu = async () => {
  siteMenuTrigger.setAttribute("aria-label", "Open main menu");
  siteMenuTrigger.setAttribute("aria-expanded", "false");
  siteMenuTrigger.classList.add("pointer-events-none");
  siteMenu.setAttribute("aria-hidden", "true");

  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    const timeline = gsap.timeline({
      paused: true,
    });

    if (window.matchMedia("(max-width: 767px)").matches) {
      timeline.to(".site-menu-mobile-close", {
        yPercent: 200,
        opacity: 0,
        duration: 0.3,
        ease: "expoScale(0.5, 7, none)",
      });
    }

    timeline.to(".site-menu-bottom-line", { width: 0 }, "<");
    timeline.to(".site-menu-section-line", { height: 0 }, "<");

    timeline.to(
      ".site-menu-actions a, .site-menu-actions button, .site-menu-wrapper li",
      {
        y: "60%",
        opacity: 0,
        duration: 0.25,
        ease: "expoScale(0.5, 7, none)",
      },
      "<50%",
    );

    timeline.to(".site-menu-wrapper", { xPercent: -100, duration: 0.3, ease: "expoScale(0.5, 7, none)" });

    if (window.matchMedia("(max-width: 767px)").matches) {
      timeline.to(
        ".site-menu-circles",
        { xPercent: -200, yPercent: -200, duration: 0.6, ease: "expoScale(0.5, 7, none)" },
        "<50%",
      );
    }

    await timeline.play();
  }

  document.documentElement.classList.remove("js-menu-active");
  siteMenuTrigger.classList.remove("pointer-events-none");
};

export default {
  init: () => {
    on("click", ".site-menu-trigger", (e) => {
      const trigger = e.currentTarget;

      if (trigger.getAttribute("aria-expanded") === "true") {
        closeMenu();
      } else {
        openMenu();
      }
    });

    on("click", ".site-menu-close", () => {
      closeMenu();
    });

    on("click", ".site-menu", (e) => {
      if (!e.target.closest(".site-menu-wrapper")) {
        closeMenu();
      }
    });

    on("click", ".site-search-toggle", (e) => {
      const form = document.getElementById(e.currentTarget.getAttribute("aria-controls"));

      if (form.classList.contains("invisible")) {
        form.classList.remove("invisible");
        form.querySelector('[type="search"]').focus();
      } else {
        form.classList.add("invisible");
      }
    });

    on("click", '.search-form [type="reset"]', (e) => {
      const form = e.currentTarget.closest("form");

      form.classList.add("invisible");
    });
  },
};
